module.exports = __webpack_public_path__ + "static/media/siemens.e25ea6bc.png";